/*
    Data display for an individual trip record

    The bus id and/or passenger counts can be clicked on to edit their value in place

    The whole row can be click to expand into the big and complicated details view

    Records can be marked as "selected" in order to perform bulk operations
*/

import React, { createRef } from "react";

import StyledCheckbox from "../Components/StyledCheckbox";

import BusOpsDetails from "../Containers/BusOpsDetails";

import MainContext from "../MainContext";
import Constants from "../Constants";

import DataItem from "../Components/DataItem";

import { departBus } from "../Requests/BusOpsRequests";
import { formatDateTime, checkDepartTimeWithinLimit } from "../Scripts/Utilities";

import { updateTripStatus } from "../Requests/BusOpsRequests";
import TripSwapDisplay from "./TripSwapDisplay";

class BusOpsData extends React.Component {
    //  Location name, lane/gate selections, “Run”, 
    // “Sched/Delay”, “Route”, “Dest”, “Return”
    // and then the Proximity Indicator

    static contextType = MainContext;

    constructor(){
        super();
        this.state = {
            editMode: false,
            passEdit: false,
            busIdEdit: false,
            passBoardingValue: null,
            passDepartingValue: null,
            busIdValue: null,
            switched: false,
            switchContent: {}
        };

        this.busIdTextRef = createRef();
        this.passTextRef = createRef();
        this.submitRef = createRef();
    }

    //
    //
    componentDidMount(){
        this.setState({
            passBoardingValue: this.props.data.passBoarding,
            passDepartingValue: this.props.data.passDeparture,
            busIdValue: this.props.data.vehicle_id
        });
    }

    //
    // switch between standard and edit mode,
    // where we can change passengers and bus id
    //
    componentDidUpdate(prevProps, prevState){
        if(!prevState.editMode && this.state.editMode){
            this.busIdTextRef.current.value = this.props.data.vehicle_id;
            this.passTextRef.current.value = this.props.data.passDeparture;

            if(this.state.busIdEdit){
                this.submitRef.current.focus();
                setTimeout(() => {
                    this.busIdTextRef.current.focus();
                }, 0);
            }
            else if(this.state.passEdit){
                this.submitRef.current.focus();
                setTimeout(() => {
                    this.passTextRef.current.focus();
                }, 0);
            }
        }
        else if(this.props.data.vehicle_id !== prevProps.data.vehicle_id
            || this.props.data.passBoarding !== prevProps.data.passBoarding
            || this.props.data.passDeparture !== prevProps.data.passDeparture) 
        {
            this.setState({
                passBoardingValue: this.props.data.passBoarding,
                passDepartingValue: this.props.data.passDeparture,
                busIdValue: this.props.data.vehicle_id
            });
        }
    }

    //
    //
    updateValue = (evt) => {
        this.setState({[evt.target.name]: evt.target.value});
    }

    //
    // mark this record as selected for the sake of mass operations
    //
    onSelect = () => {
        this.props.onSelect(this.props.containerIndex);
    }

    //
    // expand this record to show the details
    //
    expand = () => {
        if(!this.state.busIdEdit && !this.state.passEdit){
            this.props.runOpen(this.props.containerIndex);
        }
    }

    //
    // undo & revert edited bus id/passenger values
    //
    cancelEdit = () => {
        this.setState({
            editMode: false,
            passEdit: false,
            busIdEdit: false
        });
    }

    //
    //
    openBusIdEditMode = (evt) => {
        this.setState({busIdEdit: true, passEdit: false});
        this.openEditMode(evt);
    }

    //
    //
    openPassEditMode = (evt) => {
        this.setState({passEdit: true, busIdEdit: false});
        this.openEditMode(evt);
    }

    //
    //
    openEditMode = (evt) => {
        evt.stopPropagation();
        console.log("OPEN BUS ID EDIT");
        this.setState({editMode: true});
    }

    //
    // parse the values for the bus id and passenger counts for edit mode,
    // and then submit those to the API
    //
    submitEdit = () => {
        // OK, need to construct the parameters here correctly
        const params = {...this.props.data};

        console.log("ID COMPARISON", this.state.busIdValue.trim(), this.props.data.vehicle_id);

        // set the new busid value
        if(this.state.busIdValue.trim() === this.props.data.vehicle_id){
            console.log("ID MATCH");
            // if this value hasn't changed, don't overwrite it
            params.vehicleID = "";
        }
        else if(this.state.busIdValue.trim() === ""){
            params.vehicleID = "BLANK";
        }
        else{
            console.log("NO ID MATCH");
            params.vehicleID = this.state.busIdValue;
        }

        // set the passenger boarding/departure values
        const isBlank = this.state.passBoardingValue.trim() === "";

        // passArrival
        // passGetOff
        // passBoarding

        let newDeparture = null;

        if(isBlank && this.props.data.passArrival === "" && this.props.data.passGetOff === ""){
            newDeparture = "BLANK";
        }
        else{
            // just calculate the whole thing
            let arrival = parseInt(this.props.data.passArrival);
            let boarding = parseInt(this.state.passBoardingValue);
            let gettingOff = parseInt(this.props.data.passGetOff);

            arrival = isNaN(arrival) ? 0 : arrival;
            boarding = isNaN(boarding) ? 0 : boarding;
            gettingOff = isNaN(gettingOff) ? 0 : gettingOff;

            newDeparture = arrival + boarding - gettingOff;
        }

        params.boarding = isBlank ? "BLANK" : this.state.passBoardingValue;
        params.onDeparture = newDeparture;
        params.time = "";

        //
        // OK, we can set up the API request now
        //
        const request = () => updateTripStatus(params);

        const then = ({data}) => {

            console.log("UPDATE DATA", data);

            if(data){
                console.log("UPDATE THE TRIP RECORD", data);
                // this.context.sendNotification(false, `Successfully Departed: ${this.props.data.Route} ${this.props.data.Header.trim()}`);
                // update the departure display value
                // Alright, turns out I do need to do the update
                this.props.updateTrip(data, this.props.index);
                this.setState({passDepartingValue: newDeparture === "BLANK" ? "" : newDeparture});
            }
            else{
                this.context.sendNotification(true, "Failure to Update, please try again");
                // update the values back to their previous values
                this.setState({
                    passBoardingValue: this.props.data.passBoarding,
                    busIdValue: this.props.data.vehicle_id
                });
            }

            this.setState({editMode: false, passEdit: false, busIdEdit: false});
        };

        this.context.runProcessing(request, then, "updateTrip");
    }

    //
    // depart the trip!
    //
    runDeparture = () => {
        
        // test if the trip is 45 minutes or more early or late
        // if so, prompt the user to check if they intend to do this
        if(!checkDepartTimeWithinLimit(this.props.data)){
            return;
        }
        
        const request = () => departBus(this.props.data);

        const then = ({data}) => {
            if(data){
                // remove this entry?
                this.context.sendNotification(false, `Successfully Departed: ${this.props.data.Route} ${this.props.data.Header.trim()}`);
                this.props.refresh();
                /*
                else{
                    if(this.props.mode === "ALL"){
                        this.props.updateTrip(data, this.props.index);
                    }
                    else{
                        this.props.removeTrip(this.props.index);
                    }
                }
                */
            }
            else{
                this.context.sendNotification(true, "Failure to Depart, please try again");
            }
        };

        this.context.runProcessing(request, then, "departBus");
    }

//////////////////////////////////////////////////////////////////
//
//
//
//
//
//
//
// RENDER
//
//
//
//
//
//
//
//////////////////////////////////////////////////////////////////

    render() {

    /*

    {
        "TimePoint": "NWYKPABT",
        "LocationId": "PABT",
        "TripNumber": "15967344",
        "Day": "17",
        "Time": "1400",
        "SchedDepTime": "17-OCT-20 02:00 PM",
        "DepTime": "10/17/2020 2:00:00 PM",
        "Route": "154",
        "Direction": "Ou",
        "SchedLaneGate": "203-1",
        "Header": "FORT LEE     ",
        "Run": "105",
        "ManualStatus": "",
        "ManualStatusDisplay": "",
        "ManualDelay": "0",
        "ManualLaneGate": "",
        "Owner": "AUTO",
        "Color": "GRAY",
        "vehicle_id": "",
        "return_trip_time": "0300P",
        "actual_departure_time": ""
    }

    */

        //
        // set a bunch of values before rendering for the sake of 
        // code clarity within the JSX
        //

        const data = this.props.data;

        const nonStarter = this.context.user.access !== Constants.access.starter;
        const isOperator = this.context.user.access === Constants.access.operator;

        let className="data";

        let gridTemplateColumns = nonStarter ? "1fr 30fr 2fr" : "15fr 1fr";

        if(this.props.expanded || this.state.editMode){
            gridTemplateColumns = "1fr";
        }
        else{
            className += " shadow-card";
        }

        let selected = false;

        if(this.props.selectedList.includes(this.props.containerIndex)){
            selected = true;
        }

        const isHidden = data && data.DelayReason === "Hide";
        const mainStyle = isHidden
            ? { display: "none" }
            : { display:"grid",
            gridTemplateColumns,
            borderTopRightRadius:"5px",
            borderBottomRightRadius:"5px",
            position: "relative"
        };

        let cancelledOrNoShow = data.DelayReason === "NoShow" || data.DelayReason === "Cancelled";

        // always give priority to the CLEVER data
        const delayVal = data.SecLate || data.ManualDelay;
        const realtimeDelay = delayVal && `${delayVal >= 0 ? "+": ""}${Math.round(delayVal/60)}M `;

        const isBus = this.context.user.groupid === "BUS";

        // colors for the proximity detector
        const radiusOneColor = data.radius1color ? data.radius1color.toLowerCase() : "grey";
        const radiusTwoColor = data.radius2color ? data.radius2color.toLowerCase() : "grey";

        let isFilled = false;
        let isUsed = false;

        let tripFrom = null;
        let tripTo = null;

        if(data.switched){
            let classAddition = " ";

            if(data.switched.tripTo){
                classAddition = " trip-open";
                isUsed = true;
                tripTo = data.switched.tripTo;
            }

            if(data.switched.tripFrom){
                classAddition = (data.switched.tripTo ? " trip-double-swap" : " trip-filled");
                isFilled = true;
                tripFrom = data.switched.tripFrom;
            }

            console.log("SWITCH VALUES", isFilled, isUsed, data.vehicle_id, data.switched.tripTo, data.switched.tripFrom);

            // reassigned record can't be in this state
            cancelledOrNoShow = false;
        }

        const showSwitchButton = !isFilled && data.DelayReason !== "Cancelled" && data.DelayReason !== "NoShow" && !data.actual_departure_time;

        const switchSelect = (tripToIndex, isUnfilled) => {
            this.props.switchTrips(tripToIndex, this.props.containerIndex, isUnfilled, false);
        }

        const busID = isFilled ? data.switched.tripFrom.busID : this.state.busIdValue;
        let Run = data.Run;

        if(isFilled){
            console.log("IS FILLED BUS ID", data.switched, busID, tripFrom);
            Run = tripFrom.run || Run;
        }

        // console.log("BUS DATA CONTEXT", this.context);

        const gateLabel = this.context.user.currentLocation.location_id === "PABT" ? "G/D" : "L/G";

        // get the correct background color for the record
        if(data.tripcolor && data.tripcolor.toLowerCase() === "grey" || data.actual_departure_time){
            className += " data-old";
        }
        else if(!data.switched && data.tripcolor.toLowerCase() !== "blue"){
            // don't display the cancelled/no-show colors for reassigned records
            mainStyle.backgroundColor = data.tripcolor.toLowerCase();
        }

///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////

        // just hide the used-only record for now
        return (
            !(isUsed && !isFilled) && <div className={className} style={
                mainStyle
            }>
                {
                    // either expanded or standard mode
                    this.props.expanded /*&& !isUsed*/
                    ? <div>
                        <BusOpsDetails {...this.props} onClose={(departureUpdated) => {
                            this.props.runOpen(null);
                            if(departureUpdated){
                                console.log("DEPARTURE UPDATED");
                                this.props.removeFromList(this.props.containerIndex);
                            }
                        }} />
                    </div>
                    : <>
                    <TripSwapDisplay 
                        isFilled={isFilled}
                        isUsed={isUsed}
                        tripTo={tripTo}
                        tripFrom={tripFrom}
                        currentTrip={data}
                        undoSwitch={this.props.undoSwitch}
                    />
                    {
                        nonStarter && !this.state.editMode && !(isUsed && !isFilled)
                        ? <div className="data-multiselect" style={{
                            backgroundColor: selected ? "var(--red)" : "var(--light-gray)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }} onClick={this.onSelect}>
                            <StyledCheckbox checked={selected} onChange={this.onSelect} />
                        </div>
                        : null
                    }
                    {
                        !(isUsed && !isFilled)
                        ? <div style={
                            {display:"grid", 
                            gridTemplateColumns:"2fr 3fr 2fr 4fr", 
                            justifyItems: "start",
                            padding:"8px 0px 8px 32px",
                            rowGap:"4px"}
                            }
                            onClick={this.expand}
                        >
                            <span><span className="ops-label">Run:</span> <DataItem val={Run}/>
                            {
                                showSwitchButton
                                ? <span onClick={(evt) => this.props.openTripSwitch(evt, this.props.containerIndex, switchSelect)}
                                    style= {{
                                        marginLeft: "1vw",
                                        backgroundColor: "white",
                                        padding: "0.1vw 1.3vw",
                                        borderRadius: "10px"
                                    }}
                                    className="reassign-button"
                                >
                                    <i className="fas fa-random"></i>
                                </span>
                                : null
                            }
                            </span>
                            <span
                                style={{
                                    display: "flex",
                                    flexDirection: "column"
                                }}
                            >
                                {
                                    data.actual_departure_time
                                    ? <DataItem val={formatDateTime(data.actual_departure_time, null, true)} />
                                    : <>
                                        <DataItem val={formatDateTime(data.SchedDepTime, null, true)} />
                                        <DataItem val={realtimeDelay} color={data.delaycolor}>
                                            {
                                            <span style={{position: "relative", top: "1px"}}>
                                                <div style={{backgroundColor: radiusOneColor, margin:"4px 4px 0", borderRadius:"50%", width:"14px", height:"14px", display:"inline-block"}}></div>
                                                <div style={{backgroundColor: radiusTwoColor, borderRadius:"50%", marginLeft: "2px", width:"14px", height:"14px", display:"inline-block"}}></div>
                                            </span>
                                            }
                                        </DataItem>
                                    </>
                                }
                            </span>
                            <span><span className="ops-label">Route:</span> <DataItem val={
                                            (data.route_new && data.route_new !== data.route_original && !data.driver_replaced)
                                            ? data.route_new
                                            : data.Route
                                        }/></span>
                            <span style={{
                                display: "flex"
                            }}>                                
                                <span><span className="ops-label">Dest:</span>&nbsp;</span>
                                <DataItem val={data.Header && data.Header.trim()}/>
                                
                            </span>
                            <span onClick={this.openBusIdEditMode}>
                            {
                                this.state.editMode
                                ? <span className="biggerInteractive">
                                        <span>
                                        {
                                            isBus
                                            ? "Bus#: "
                                            : "Vehicle#: "
                                        }
                                        </span>&nbsp;
                                        <input className="short-input" type="number" name="busIdValue" ref={this.busIdTextRef} value={this.state.busIdValue} onChange={this.updateValue} />
                                    </span>
                                : <span className="biggerInteractive"> {
                                    this.state.busIdValue
                                    ? <><span>
                                            {
                                                isBus
                                                ? "Bus#: "
                                                : "Vehicle#: "
                                            }
                                        </span> 
                                        <DataItem val={this.props.data.vehicle_id} color={data.vehicleIDColor}/></>
                                    : <><DataItem val={isBus ? "Bus#: " : "Vehicle#: "} color={data.vehicleIDColor ? data.vehicleIDColor : "red"}/></>
                                }</span>
                            }
                            </span>
                            <span style={{display: "flex", alignItems:"center"}}>
                                <span className="ops-label">{gateLabel}:</span>&nbsp;<DataItem val={data.ManualLaneGate || data.SchedLaneGate}/>
                            </span>
                            <span className="biggerInteractive" onClick={this.openPassEditMode}>Pass#:&nbsp;
                            {
                                this.state.editMode
                                ? <input className="short-input" type="number" name="passBoardingValue" ref={this.passTextRef} value={this.state.passBoardingValue} onChange={this.updateValue} />
                                : <DataItem val={this.state.passDepartingValue}/>
                            }
                            </span>
                            {/* <span style={{display: "flex", alignItems:"center"}}>Return:&nbsp;<DataItem val={data.return_trip_time}/></span> */}
                            <span className="ops-label" style={{display: "flex", alignItems:"center"}}>
                                From:&nbsp;<DataItem val={data.previous_work} fontSize={"0.85rem"}/>
                                &nbsp;
                                To:&nbsp;<DataItem val={data.next_work} fontSize={"0.85rem"}/>
                            </span>
                        </div>
                        : null
                    }
                    {
                        // whether or not we show the depart button
                        data.actual_departure_time === "" 
                        && !isOperator
                        && !cancelledOrNoShow
                        && !this.state.editMode
                        && !(isUsed && !isFilled)
                        ?
                            <button className="option depart-button"
                                onClick={this.runDeparture}
                            >
                                DEPART
                            </button>
                        : null
                    }
                    {
                        cancelledOrNoShow && (data.DelayReason === "Cancelled" || data.DelayReason === "Lost")
                        ? <div className="delay-reason">L</div>
                        : <></>
                    }
                    {
                        cancelledOrNoShow && data.DelayReason === "NoShow"
                        ? <div className="delay-reason">NS</div>
                        : <></>
                    }
                    {
                        // whether or not we show the edit submit/cancel buttons
                        this.state.editMode
                        ? <div style={{
                            margin:"6px"
                        }}>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "4fr 1fr",
                                gap: "4px",
                                width: "100%"
                            }}>
                                <button ref={this.submitRef} className="option" onClick={this.submitEdit}>Submit Values</button>
                                <button className="option" onClick={this.cancelEdit}>Cancel</button>
                            </div>
                        </div>
                        : null
                    }
                    </>
                }
            </div>
        )
    }
}

export default BusOpsData;